import { useFocusTrap } from "../hooks/useFocusTrap";
import styles from "./WinModal.module.css";

interface LoseModalProps {
  swapsUsed: number;
  maxSwaps: number;
  onKeepPlaying: () => void;
  onRetry?: () => void;
  onStats?: () => void;
  onLeaderboard?: () => void;
  nextAction?: { label: string; onClick: () => void };
}

export function LoseModal({
  swapsUsed,
  maxSwaps,
  onKeepPlaying,
  onRetry,
  onStats,
  onLeaderboard,
  nextAction,
}: LoseModalProps) {
  const trapRef = useFocusTrap<HTMLDivElement>();
  return (
    <div className={styles.overlay} onClick={onKeepPlaying} onKeyDown={(e) => { if (e.key === "Escape") onKeepPlaying(); }}>
      <div className={styles.modal} role="dialog" aria-modal="true" ref={trapRef} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeX} onClick={onKeepPlaying} aria-label="Close" autoFocus>&times;</button>
        <h2 className={styles.ratingLost}>Out of swaps!</h2>
        <p className={styles.stats}>
          You used all <strong>{maxSwaps}</strong> allowed swaps
          <br />
          after <strong>{swapsUsed}</strong> moves.
        </p>
        <p className={styles.statsSecondary}>
          You can keep playing, but your score won't count.
        </p>
        <div className={styles.actions}>
          <button className={styles.keepPlayingButton} onClick={onKeepPlaying}>
            Keep Playing
          </button>
          {onRetry && (
            <button className={styles.newGameButton} onClick={onRetry}>
              Try Again
            </button>
          )}
          {nextAction && (
            <button className={styles.newGameButton} onClick={nextAction.onClick}>
              {nextAction.label}
            </button>
          )}
        </div>
        {(onStats || onLeaderboard) && (
          <div className={styles.linkRow}>
            {onStats && <button className={styles.linkButton} onClick={onStats}>Stats</button>}
            {onLeaderboard && <button className={styles.linkButton} onClick={onLeaderboard}>Leaderboard</button>}
          </div>
        )}
      </div>
    </div>
  );
}
